import { render, staticRenderFns } from "./BloqueodefechasQuicktable.vue?vue&type=template&id=229e5ef3&"
import script from "./BloqueodefechasQuicktable.vue?vue&type=script&lang=js&"
export * from "./BloqueodefechasQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports